module.exports = __webpack_public_path__ + "static/media/ko-to-tamo-scenario-3.6d51b246.png";